import gql from 'graphql-tag';
import showToaster from '../../../helpers/showToaster';

const mutation = gql`
mutation manualPayout($id: Int!, $isPayoutStatus: Boolean!) {
  manualPayout(id: $id, isPayoutStatus: $isPayoutStatus) {
    status
    errorMessage
  }
}
`;

export default function manualPayout(variables) {
    return async (dispatch, getState, { client }) => {
        try {
            const { data } = await client.mutate({
                mutation,
                variables,
            });

            if (data && data.manualPayout && data.manualPayout.status === 200) {
                showToaster({ messageId: 'statusUpdate', toasterType: 'success' })
                return { status: 200 }
            } else {
                showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: data?.manualPayout?.errorMessage })
            }
            return true;
        }
        catch (error) {
            showToaster({ messageId: 'catchError', toasterType: 'error', requestContent: error })
            return false;
        }
    };
}